export enum CallToActionType {
  CALL_PHONE_NUMBER = 'CALL_PHONE_NUMBER',
  VISIT_WEBSITE = 'VISIT_WEBSITE',
}
